<template>
  <v-locale-provider>
    <router-view></router-view>
    <snackbar></snackbar>
    <v-fade-transition>
      <VBtn
        v-show="isVisible"
        icon="mdi-arrow-up"
        color="primary"
        elevation="8"
        class="back-to-top"
        @click="scrollToTop"
      />
    </v-fade-transition>
  </v-locale-provider>
</template>
<script>
import { mapGetters } from 'vuex';
import Snackbar from '@/components/common/Snackbar/Snackbar.vue';
export default {
  components: {
    Snackbar
  },
  computed: {
    ...mapGetters('main', ['isLoading'])
  },
  mounted() {
    // Bind native browser scroll events when the component loads
    window.addEventListener('scroll', this.checkScroll);
  },

  unmounted() {
    // Clean up event listener to prevent memory leaks
    window.removeEventListener('scroll', this.checkScroll);
  },

  methods: {
    // Check scroll position to toggle button visibility
    checkScroll() {
      this.isVisible = window.scrollY > 300;
    },

    // Perform smooth scrolling to the top of the viewport
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  data() {
    return {
      // State managing visibility of the button
      isVisible: false
    };
  }
};
</script>
<style scoped>
/* Pins the button to the bottom-right corner of the viewport */
.back-to-top {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 99;
}
</style>
